import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { Lock, Eye, EyeOff, ArrowRight, XCircle } from 'lucide-react';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const invalid = !token;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error('Password must be at least 6 characters');
    if (password !== confirmPassword) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await authAPI.resetPassword({ token, password });
      toast.success('Password updated! Please sign in with your new password.');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout" style={{ justifyContent: 'center', background: 'linear-gradient(135deg, #eef2ff 0%, #fdf2f8 100%)' }}>
      <div className="auth-form-panel" style={{ maxWidth: 520 }}>
        <div className="auth-form-wrapper">
          <div className="auth-card">
            <div className="auth-card-header">
              <div className="auth-form-logo">
                <img src="/favicon.svg" alt="LedgerPro" className="auth-form-logo-img" />
              </div>
              <h2>Set a new password</h2>
              <p>Choose a strong new password for your account.</p>
            </div>
            <div className="auth-card-body">
              {invalid ? (
                <div style={{ textAlign: 'center', padding: '10px 0' }}>
                  <XCircle size={44} color="#dc2626" style={{ marginBottom: 10 }} />
                  <h3 style={{ margin: '0 0 8px', color: '#334155' }}>Invalid reset link</h3>
                  <p style={{ margin: '0 0 18px', fontSize: 13.5, color: '#64748b' }}>
                    This link is missing or malformed. Please request a fresh one.
                  </p>
                  <Link to="/forgot-password">
                    <button className="auth-submit auth-submit-primary" type="button">Request new link</button>
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="auth-field">
                    <label>New Password</label>
                    <div className="auth-input-icon auth-input-with-toggle">
                      <Lock size={18} className="auth-input-icon-svg" />
                      <input className="auth-input" type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 6 characters" autoFocus required minLength={6} />
                      <button type="button" className="auth-pw-toggle" onClick={() => setShowPw(v => !v)}>
                        {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                  </div>
                  <div className="auth-field">
                    <label>Confirm Password</label>
                    <div className="auth-input-icon">
                      <Lock size={18} className="auth-input-icon-svg" />
                      <input className="auth-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Repeat the password" required />
                    </div>
                  </div>
                  <button className="auth-submit auth-submit-primary" type="submit" disabled={loading}>
                    {loading ? (
                      <><span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> Updating...</>
                    ) : (
                      <>Update password <ArrowRight size={16} /></>
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="auth-footer">
            Remembered it? <Link to="/login">Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
